export default "__VITE_ASSET__DXGiWszs__"